class Robot {
    constructor() {
      this.info = {
        Id : "",
        RobotId : "",
        RobotTypeId : "",
        RobotSiteId : "",
        RobotVersionId : "",
        FabricationDate : null,
        DeployedDate : null,
        DecomDate : null,
        CreatedAt : null,
        UpdatedAt : null,
        CreatedBy : "",
        UpdatedBy : "",
        RegistrationDate : null,
        RobotSoftwareId : "",
        RegistrationKey : "",
        Status : "",
        ActivationStatus : false,
      }
      this.status = {
        Id : "",
        CreatedAt : null,
        BatteryTemperature : 0.0,
        BatteryLevel : 0,
        Charging : false,
        RobotMapId : "",
        RobotTask : "",
        Status : "",
        RobotTableId : "",
        RobotStatusCodeId : "",
        LocationX : 0.0,
        LocationY : 0.0,
        LocationZ : 0.0,
        Location : "",
        Angle : 0,
        Speed : 0,
        Localisation : false,
        IsTaskEnded : false,
        Estop : false,
      }
      this.laser = {
            RobotTableId: "",
            CurrentPosition: {
              Angle: 0,
              X: 0,
              Y: 0,
            },
            RobotLaser: [
              {
                X: 0,
                Y: 0,
              }
            ],
          }
    }
  }
  
export default Robot;